import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=1a48e251&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"
import style0 from "./Chip.vue?vue&type=style&index=0&id=1a48e251&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a48e251",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a48e251')) {
      api.createRecord('1a48e251', component.options)
    } else {
      api.reload('1a48e251', component.options)
    }
    module.hot.accept("./Chip.vue?vue&type=template&id=1a48e251&scoped=true", function () {
      api.rerender('1a48e251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/chips/Chip.vue"
export default component.exports